// ========== Start Announcement Bar Slider ==========
var slider = new KeenSlider("#announcement__slider", {
  loop: true,
  defaultAnimation: {
    duration: 3000,
  }
}, 
[
  navigation,
  (slider) => {
    let timeout
    let mouseOver = false
    function clearNextTimeout() {
      clearTimeout(timeout)
    }
    function nextTimeout() {
      clearTimeout(timeout)
      if (mouseOver) return
      timeout = setTimeout(() => {
        slider.next()
      }, 5000)
    }
    slider.on("created", () => {
      slider.container.addEventListener("mouseover", () => {
        mouseOver = true
        clearNextTimeout()
      })
      slider.container.addEventListener("mouseout", () => {
        mouseOver = false
        nextTimeout()
      })
      nextTimeout()
    })
    slider.on("dragStarted", clearNextTimeout)
    slider.on("animationEnded", nextTimeout)
    slider.on("updated", nextTimeout)
  },
])
// ========== End Announcement Bar Slider ==========
window.announcementSlider = slider;
const announcementSlider = document.querySelector("#announcement__slider")

let listening = true;

slider.on("created", checkSlideNumber);
slider.on("animationEnded", checkSlideNumber);

function checkSlideNumber(s) {
    if (!listening) return;
    checkIfSecondSlide(s);
}

function checkIfSecondSlide(s) {
  const currentIndex = s?.track?.details?.rel; // 0-based
  const currentSlide = s.slides[currentIndex]; // the actual DOM element
  if (currentSlide.querySelector(".announcement-bar__message--affiliate")) {
    listening = false;

    Array.from(announcementSlider.children).forEach((slide) => {
      if (slide != currentSlide) {
        slide.remove(); 
      }
    });
    window?.announcementSlider.destroy()

  }
}
